module.exports = __webpack_public_path__ + "img/two.1de82268.svg";